/**
 * 路由配置 - 完全兼容SSR环境
 */

// 导入所有必要的函数
import { createMemoryHistory, createRouter, createWebHistory } from "vue-router";

// 路由配置
const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue"),
  },
  {
    path: "/category",
    name: "Category",
    component: () => import("@/views/category/Category.vue"),
  },
  {
    path: "/category/:id",
    name: "CategoryDetail",
    component: () => import("@/views/category/CategoryDetail.vue"),
  },
  {
    path: "/news",
    name: "News",
    component: () => import("@/views/news/News.vue"),
  },
  {
    path: "/news/:id",
    name: "NewsDetail",
    component: () => import("@/views/news/NewsDetail.vue"),
  },
  {
    path: "/news-media",
    name: "NewsMedia",
    component: () => import("@/views/news/NewsMedia.vue"),
  },
  {
    path: "/exhibition",
    name: "Exhibition",
    component: () => import("@/views/exhibition/Exhibition.vue"),
  },
  {
    path: "/exhibition/:id",
    name: "ExhibitionDetail",
    component: () => import("@/views/exhibition/ExhibitionDetail.vue"),
  },
  {
    path: "/industry",
    name: "Industry",
    component: () => import("@/views/Industry.vue"),
  },
  {
    path: "/history",
    name: "History",
    component: () => import("@/views/History.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/views/About.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/user/profile",
    name: "UserProfile",
    component: () => import("@/views/user/Profile.vue"),
  },
  {
    path: "/user/account",
    name: "UserAccount",
    component: () => import("@/views/user/Account.vue"),
  },
  {
    path: "/user/projects",
    name: "UserProjects",
    component: () => import("@/views/user/Projects.vue"),
  },
  {
    path: "/user/works",
    name: "UserWorks",
    component: () => import("@/views/user/Works.vue"),
  },
  {
    path: "/user/upload",
    name: "UserUpload",
    component: () => import("@/views/user/Upload.vue"),
  },
  {
    path: "/legal/terms",
    name: "TermsOfService",
    component: () => import("@/views/legal/TermsOfService.vue"),
  },
  {
    path: "/legal/privacy",
    name: "PrivacyPolicy",
    component: () => import("@/views/legal/PrivacyPolicy.vue"),
  },
  {
    path: "/legal/copyright",
    name: "CopyrightNotice",
    component: () => import("@/views/legal/CopyrightNotice.vue"),
  },
  {
    path: "/notice",
    name: "Notice",
    component: () => import("@/views/Notice.vue"),
  },
];

// 创建一个工厂函数来安全地创建路由实例
function createRouterInstance() {
  // 检查是否在服务器环境中
  const isServer = typeof window === 'undefined';
  
  // 只在服务器端使用createMemoryHistory，避免在导入时访问window
  const history = isServer 
    ? createMemoryHistory() 
    : createWebHistory();
  
  return createRouter({
    history,
    routes,
    // 切换路由时重置滚动条位置
    scrollBehavior() {
      return { top: 0 };
    },
  });
}

// 创建路由实例
const router = createRouterInstance();

export default router;
